import mixpanel from 'mixpanel-browser';

import { User } from '../auth/useUser';
import { EAnalyticsEvents } from '../enums';
import { roleFlags } from '../utils/roleFlags';
import { isDevelopment } from '../utils/environments';

type MixpanelEvent = {
  event: EAnalyticsEvents;
  user?: User;
  properties?: Record<string, string | number | boolean | string[]>;
  employeeRole?: { role?: string } | null;
};

function fireEvent({ event, properties, user, employeeRole }: MixpanelEvent) {
  if (!process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || isDevelopment()) {
    return;
  }
  try {
    const roles = roleFlags(employeeRole?.role);
    mixpanel.track(event, {
      ...properties,
      globalId: user?.globalId,
      band: user?.band,
      zone: user?.zone,
      isManager: roles.isManager,
      isSuperAdmin: roles.isSuperAdmin,
      isGlobalAdmin: roles.isGlobalAdmin,
      isZoneAdmin: roles.isZoneAdmin,
      isPBP: roles.isPBP,
      isTalentManager: roles.isTalentManager,
    });
  } catch (err) {
    console.error(err);
  }
}

export const mixPanel = {
  fireEvent,
};
